import PropTypes from 'prop-types';

export const propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    imageFilename: PropTypes.string,
    imageContentType: PropTypes.string,
    imageUrl: PropTypes.string,
    headline: PropTypes.string,
    byline: PropTypes.string,
    registerButtonCopy: PropTypes.string,
  }),
};

export const defaultProps = {
  banner: {
    id: null,
    name: '',
    imageFilename: null,
    imageContentType: null,
    imageUrl: null,
    headline: '',
    byline: '',
    registerButtonCopy: '',
  },
};
